import { Component } from '@angular/core';

@Component({
    selector: 'app-page-not-found',
    template: `
        <div style="padding: 0">
            <div class="alert alert-danger">
                {{ 'aumico_reports_page_not_found' | i18next }}
            </div>
        </div>
    `,
})
export class PageNotFoundComponent {}
